import minusIcon from '@disy/cadenza-icons/minus.svg';
import notPublishedIcon from '@disy/cadenza-icons/pub-state-not-published.svg';
import publishedOutOfDateIcon from '@disy/cadenza-icons/pub-state-out-of-date.svg';
import publishedIcon from '@disy/cadenza-icons/pub-state-up-to-date.svg';
import { icon } from '@disy/lib/icon';

import i18n from 'cadenza/admin/ui/publication-state-icon/publication-state-icon.properties';
import type { PublicationState } from 'cadenza/api-client/dto/publication-state';

import './publication-state-icon.css';

export function renderPublicationState(state: PublicationState | 'PUBLISHING_DISABLED') {
  const size = 's';
  const label = i18n(`publication-state.<${state}>`);
  switch (state) {
    case 'PUBLISHED':
      return icon(publishedIcon, { size, label, styleClass: 'published-state' });
    case 'PUBLISHED_UPDATED':
      return icon(publishedOutOfDateIcon, { size, label, styleClass: 'published-updated' });
    case 'NOT_PUBLISHED':
      return icon(notPublishedIcon, { size, label, styleClass: 'not-published' });
    case 'PUBLISHING_DISABLED':
      return icon(minusIcon, { size: 'xs', label });
  }
}
